import $ from 'jquery';
import { lazyLoadObserve } from './lazyLoad';
import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

// After loading new elements on filtering re-init the Lozad observer
$(document).on('facetwp-loaded', function() {
  const defaultObserver = lazyLoadObserve();
  defaultObserver.observe();

  Jump('.main', {
    duration: 800,
    easing: easeOutQuad,
  });
});
